import cookie from 'js-cookie'
import ajaxUtil from 'cy_static/ajaxUtil'
import { server } from '../../../assets/config/env'
import spaceImg from '../../../assets/img/space.png'

export default {
  name: 'CardOfArticle',

  props: {
    data: {
      required: true
    }
  },

  data() {
    return {
      imgCDNHost: server.imgUrl,
      spaceImg,
      picHeight:[],
      a: 0,
      cdnOrigin:location.host==='m.changyoyo.com'?'https://image.changyoyo.com':''
    }
  },

  computed: {
    displayCard:  function() {
      let display = true

      // 商品
      if (this.data.contentType === '02') {

        // 限时抢购商品
        if (this.data.goodsInfo && parseInt(this.data.goodsInfo.goodsuse) === 8) {
          if (this.data.sysDateMills > this.data.goodsInfo.endTime) {
            display = false
          }
        }
      }

      return display
    }
  },
  mounted() {
    // this.$emit('getLeftHeight', this.$refs.offsetHeight.offsetHeight)
    // this.$emit('getRightHeight', this.$refs.offsetHeight.offsetHeight)
  },

  methods: {
    onImgLoad(e) {
      const imgEl = e.currentTarget

      if (imgEl.getAttribute('data-type') !== 'error') {
        const imgRatio = imgEl.offsetWidth / this.data.picWidth

        imgEl.style.height = this.data.picHeight * imgRatio + 'px'
        imgEl.style.minHeight = '0px'
      }
    },

    onImgErr(e) {
      const imgEl = e.currentTarget

      imgEl.src = spaceImg
      imgEl.style.backgroundColor = '#eee',
      imgEl.setAttribute('data-type', 'error')
    },

    onPraiseClick(e) {
      if (!cookie.get('login_token')) {
        location.href = '/auth/loginbypwd.html?callback=' + encodeURIComponent([
          location.protocol,
          '//',
          location.host,
          location.pathname,
          '#/homepage'
        ].join(''))
      } else {
        if (this.data.praiseStatus === 1) {
          this.data.praiseNum -= 1
          this.data.praiseStatus = 0
        } else {
          this.data.praiseNum += 1
          this.data.praiseStatus = 1
        }

        this._saveData()
        this._clearCache()
      }
    },

    onCardClick(data) {
      if (data.spuUrl && data.spuUrl !== '1') {
        location.href = data.spuUrl
      } else {
        if(data.productType === '03') {
          location.href = '/mall2/recharge/index.html?appId=Changyoyo_Life_Central&spuCode=' + data.spuCode
        } else {
          location.href = '/mall2/cy/goodsDetail/index.html?spuCode=' + data.spuCode + '&appId=Changyoyo_Life_Central'
        }
      }
    },

    _saveData() {
      ajaxUtil.loadData("/pointgate/goodsArticle/goodsArticlePraiseAction", {
        method: 'POST',
        standard:'standard',
        body: {
          login_token: cookie.get('login_token'),
          articleId: this.data.articleId,
          praiseAction: this.data.praiseStatus
        }
      })
    },

    _clearCache() {
      setTimeout(() => {
        const category = this.data.categoryId.split(',')

        while(category.length) {
          const id = category.shift()
          let index = 1
          let key = 'CHANGYO_HOME_WATERFALL_' + id.toLocaleUpperCase() + '_'

          while(sessionStorage.getItem(key + index)) {
            sessionStorage.removeItem(key + index)
          }
        }
      }, 100)
    }
  }
}
